/**
 * Dependencies.
 */
import { mainStore } from '@/modules/main/store';

/**
 * Export `CountryUtils`.
 */
export default class CountryUtils {
  /**
   * Countries.
   */
  static countries: {
    [key: string]: {
      zipCode: {
        blocks: number[];
        delimiter: string;
        mask: string;
        regex: RegExp;
        maxLength: number;
      };
    };
  } = {
    DE: {
      zipCode: {
        blocks: [5],
        delimiter: '',
        mask: '#####',
        maxLength: 5,
        regex: /^\d{5}$/
      }
    },
    ES: {
      zipCode: {
        blocks: [5],
        delimiter: '',
        mask: '#####',
        maxLength: 5,
        regex: /^\d{5}$/
      }
    },
    FR: {
      zipCode: {
        blocks: [5],
        delimiter: '',
        mask: '#####',
        maxLength: 5,
        regex: /^\d{5}$/
      }
    },
    IT: {
      zipCode: {
        blocks: [5],
        delimiter: '',
        mask: '#####',
        maxLength: 5,
        regex: /^\d{5}$/
      }
    },
    PT: {
      zipCode: {
        blocks: [4, 3],
        delimiter: '-',
        mask: '####-###',
        maxLength: 8,
        regex: /^\d{4}\-\d{3}$/
      }
    }
  };

  /**
   * Country.
   */
  static get country() {
    const { countryCode } = mainStore;

    return this.countries[countryCode];
  }

  /**
   * Zip code mask.
   */
  static get zipCodeMask() {
    const { zipCode } = this.country || {};

    return zipCode;
  }

  /**
   * Is zip code valid.
   */
  static isZipCodeValid(zipCode: string) {
    let isValid = true;

    const { zipCode: { maxLength = null, regex = null } = {} } =
      this.country || {};

    if (regex) {
      isValid = maxLength
        ? regex.test(zipCode.slice(0, maxLength))
        : regex.test(zipCode);
    }

    return isValid;
  }
}
